import { Link } from "react-router-dom";
import styled from "styled-components";

const StyledLink = styled(Link)`
align-self: center;
font-size: 14px;
color: var(--secondary-forest-green);
&:visited {
  color: var(--secondary-forest-green);
}
`;

export const TextLink = ({text, ...props}) => {
    return (
        <StyledLink {...props}>{text}</StyledLink>
    )
}